module.exports = __webpack_public_path__ + "assets/91e42db1.png";